// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'

const serveName = process.env.VUE_APP_SERVENAME

// 查询订单列表
export const queryOrderList = (data: any) => request(`/${serveName}/order/list`, null, 'POST_JSON', data)

// 查询订单列表
export const queryOrderListV2 = (data: any) => request(`/${serveName}/order/v2/list`, null, 'POST_JSON', data)

// 查询订单详情 事件日志
export const queryOrderEventDetail = (data: any) =>
  request(`/${serveName}/order/getOrderEvent`, null, 'POST_JSON', data)

// 查询订单详情
export const queryOrderDetail = (data: any) => request(`/${serveName}/order/detail`, null, 'POST_JSON', data)

//手动复送接口
export const resendOrder = (data: any) => request(`/${serveName}/order/fix/update`, null, 'POST_JSON', data)

//查询复送接口
export const queryResendOrder = (data: any) => request(`/${serveName}/order/fix/get`, null, 'POST_JSON', data)

//导出订单列表
export const exportOrderList = (data: any) => request(`/${serveName}/order/export`, null, 'POST_DOWNLOAD', data)

// 提交退款
export const refundSubmit = (data: any) => request(`/${serveName}/order/refund/submit`, null, 'POST_JSON', data)

// 批量提交退款
export const batchRefundSubmit = (data: any) => request(`/${serveName}/order/refund/batch/submit`, null, 'POST_JSON', data)

// 查询退款订单
export const queryRefundList = (data: any) =>
  request(`/${serveName}/order/refund/approval/list`, null, 'POST_JSON', data)

// 重新提交退款
export const retryRefundSubmit = (data: any) => request(`/${serveName}/order/refund/update`, null, 'POST_JSON', data)

// 重新提交退款
export const retryRefundApi = (data: any) => request(`/${serveName}/order/refund/retry`, null, 'POST_JSON', data)

// 查询复送订单列表V2
export const queryResendOrderListV2 = (data: any) =>
  request(`/${serveName}/order/v2/reship/list`, null, 'POST_JSON', data)

// 查询订单统计
export const queryOrderStatistics = (data: any) =>
  request(`/${serveName}/order/queryOrderStatistics`, null, 'POST_JSON', data)
